import React from "react";
import bagIcon from "../../../../../img/bagIcon2.png";
import Card from "./Card";

const OrderReview = ({ cart, ruppeeData }) => {
  return (
    <div className="card-wrap cartList">
      <div
        className="d-flex align-items-center sec-title"
        style={{ marginBottom: "16px" }}
      >
        <img
          src={bagIcon}
          alt="titleImg"
          style={{ width: "16px", minWidth: "16px", marginRight: "12px" }}
        />
        <h2>Order Review</h2>
      </div>
      <div className="combo-items">
        {cart.map((item) => {
          let hideBTN = 0;
          if (ruppeeData?.length) {
            hideBTN = ruppeeData.findIndex((ruppeeItem) => {
              if (ruppeeItem?.pID === item?.pID) {
                return true;
              }
            });
          }
          return <Card key={item.pID} item={item} hideBTN={hideBTN + 1} />;
        })}
      </div>
    </div>
  );
};

export default OrderReview;
